import { useQuery } from '@tanstack/react-query';
import { UploadedTemplate } from 'src/data-capture/hooks/templates/useTemplates';

type useTemplateProps = {
  companyId: string;
  templateId: string;
};

export const useTemplate = ({ companyId, templateId }: useTemplateProps) => {
  const { data, isLoading, isError, error } = useQuery<UploadedTemplate>({
    queryKey: ['admin', 'companies', companyId, 'templates', templateId],
  });

  return {
    template: data,
    isTemplateLoading: isLoading,
    isTemplateError: isError,
    templateError: error,
  };
};
